export default {
    getAllManagements: env => {
        return {
            url: `/${env}/managements`,
            method: 'GET',
        };
    },

    getManagementsByBrandId: (env, brandId) => {
        return {
            url: `/${env}/managements/brandId/:brandId`,
            method: 'GET',
            route_params: {
                brandId,
            },
        };
    },
    getManagementDetails: (env, managementId) => {
        return {
            url: `/${env}/managements/:managementId`,
            method: 'GET',
            route_params: {
                managementId,
            },
        };
    },
    updateManagementDetails: (env, managementId, managementForm) => {
        return {
            url: `/${env}/managements/:managementId`,
            method: 'PATCH',
            route_params: {
                managementId,
            },
            patch_params: {
                libelle: managementForm.libelle,
                buildingType: managementForm.buildingType,
                address: managementForm.address,
                city: managementForm.city,
                postalCode: managementForm.postalCode,
                weatherCity: managementForm.weatherCity,
                details: JSON.stringify(managementForm.details),
            },
        };
    },
    addManagement: (env, managementForm) => {
        let params = {};
        Object.keys(managementForm).map(field => {
            if (managementForm[field] !== null) params[field] = managementForm[field];
        });

        params.details = JSON.stringify(params.details);
        return {
            url: `/${env}/managements/add`,
            method: 'POST',
            post_params: params,
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Managements/api.js